import { render, staticRenderFns } from "./QuickpickDesktop.vue?vue&type=template&id=365329a6&scoped=true"
import script from "./QuickpickDesktop.vue?vue&type=script&lang=js"
export * from "./QuickpickDesktop.vue?vue&type=script&lang=js"
import style0 from "./QuickpickDesktop.vue?vue&type=style&index=0&id=365329a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365329a6",
  null
  
)

export default component.exports